import React, { useReducer, useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import {
  Button,
  Modal,
} from "react-bootstrap";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../../../config/toastNotification";
import BlockSuccessMessage from "../../../../UI/errorMessages/BlockSuccessMessage";
import FormErrorMessage from "../../../../UI/errorMessages/FormErrorMessage";
import CMSFormInput from "../../../../UI/forms/CMSFormInput";
import CMSFormSelect from "../../../../UI/forms/CMSFormSelect";
import axios from "../../../../../config/axios";
import {
  addItemInitialState,
  addItemReducer,
} from "../../reducers/addQuestionReducer";
import BlockErrorMessage from "../../../../UI/errorMessages/BlockErrorMessage";


const UpdateQuestionModal = ({ show, setShow, question, loadItem }) => {
  const [state, dispatch] = useReducer(addItemReducer, addItemInitialState);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    dispatch({
      type: "FETCH_SUCCESS",
      payload: {},
    });
  }, [show]);

  const onSubmit = async (data, resetForm) => {
    dispatch({
      type: "FORM_SUBMISSION_REQUEST",
    });

    try {
      const res = await axios.post(
        `poll-questions/update-question/${question._id}`,
        data
      ); //

      resetForm();
      handleClose();
      dispatch({
        type: "FORM_INITIAL_STAGE",
      });
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Question added successfully.`,
        type: "success",
      });
      loadItem();
    } catch (error) {
      dispatch({
        type: "FORM_SUBMISSION_FAILED",
        payload: error,
      });
      setTimeout(() => {
        dispatch({
          type: "FORM_INITIAL_STAGE",
        });
      }, 5000);
    }
  };

  return (
    <Formik
      initialValues={{
        optionValidation: question.optionValidation,
        question: question.question,
        sortOrder: question.sortOrder,
      }}
      validationSchema={yup.object({
        optionValidation: yup.string().required("Required"),
        question: yup.string().required("Required"),
        sortOrder: yup.number(),
      })}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={false}
      onSubmit={async (values, { resetForm }) => {
        //console.log(values);
        onSubmit(values, resetForm)
      }}
    >
      {(form) => (
        <Modal show={show} onHide={handleClose} size="lg">
          {/* {console.log(form.errors)} */}
          {state.isLoading && (
            <div class="overlay ">
              <i class="fas fa-2x fa-sync-alt text-white fa-spin"></i>
            </div>
          )}

          {state.error && state.status === "fetchFailed" ? (
            <BlockErrorMessage error={state.error} />
          ) : (
            <>
              <Form onSubmit={form.handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title>Update Question </Modal.Title>
                </Modal.Header>


                {state.status === "submitted" ? (
                  <Modal.Body>
                    <BlockSuccessMessage
                      heading="Done!"
                      message={`Question added to poll successfully.`}
                    />
                  </Modal.Body>
                ) : (
                  <>
                    <Modal.Body>
                      {state.error && <FormErrorMessage error={state.error} />}

                      <CMSFormInput
                        name="question"
                        label="Question"
                        form={form}
                        required={true}
                      />

                      <CMSFormInput
                        name="sortOrder"
                        label="Sort Order"
                        form={form}
                        required={false}
                      />

                      <CMSFormSelect
                        name="optionValidation"
                        label="Option Validation(Single/Multiple)"
                        required={true}
                        form={form}
                        options={[
                          { value: "Allow Single Selection", label: "Allow Single Selection" },
                          { value: "Allow Multiple Selection", label: "Allow Multiple Selection" }
                        ]}
                      />

                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>
                        Close
                      </Button>
                      <Button variant="primary" type="submit">
                        Submit
                      </Button>
                    </Modal.Footer>
                  </>
                )}
              </Form>
            </>
          )}
        </Modal>
      )}
    </Formik>
  );
};

export default UpdateQuestionModal;
